import { useState } from "react";

export default function useController() {
  const [isDatePickerOpen, setIsDatePickerOpen] = useState(false);

  const onAcceptDate = () => {
    setIsDatePickerOpen(false);
  };
  const openPicker = () => {
    setIsDatePickerOpen(!isDatePickerOpen);
  };

  const closePicker = () => {
    setIsDatePickerOpen(false);
  };

  return {
    isDatePickerOpen,
    openPicker,
    onAcceptDate,
    closePicker,
  };
}
